module.exports = __webpack_public_path__ + "static/img/anxun63.ba1ac69b.png";